// extracted by mini-css-extract-plugin
module.exports = {"layout":"gFyniMZQ","main":"n2Bv29x_","fullWidth":"MRbYyEr_","noMargins":"Z57BPDiM","adPlaceholder":"DdjKqYde"};